import { PageAudienceFilter, usePageFilterContext } from '@/components/page';
import { PendoPlaceholder } from '@/components/PendoPlaceholder';
import ShareMenu from '@/features/ShareMenu';

const ChannelOverviewActions = () => {
  const {
    pageFilters: { audience },
  } = usePageFilterContext();

  return (
    <div className="flex items-center gap-2">
      <PendoPlaceholder />
      <PageAudienceFilter />
      <ShareMenu
        notificationPageKey="channels"
        notificationParams={{
          audienceId: audience?.id,
        }}
      />
    </div>
  );
};

export default ChannelOverviewActions;
